import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/static/home/arrow-down.svg'


const _withScopeId = n => (_pushScopeId("data-v-6a942e84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indication-training" }
const _hoisted_2 = { class: "dropdown-row-content" }
const _hoisted_3 = { class: "training__name" }
const _hoisted_4 = { class: "right-actions" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "dropdown__arrow-down",
  src: _imports_0,
  alt: "Seta para baixo"
}, null, -1))
const _hoisted_7 = { class: "table" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "table__title" }, "Usuários indicados", -1))
const _hoisted_9 = { class: "statistics-content" }
const _hoisted_10 = { class: "user__name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PersonPhoto = _resolveComponent("PersonPhoto")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_DropdownContent = _resolveComponent("DropdownContent")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indications, (indication, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "trainings",
          key: index
        }, [
          _createVNode(_component_Dropdown, {
            key: indication.id,
            id: indication.id.toString(),
            "is-clickable": "",
            onClick: ($event: any) => (_ctx.loadIndicationByUsers(indication.id))
          }, {
            "dropdown-row": _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(indication.title), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("button", {
                    class: "button-indication",
                    onClick: _withModifiers(($event: any) => (_ctx.goToCourse(indication.id)), ["stop"])
                  }, " Ver treinamento ", 8, _hoisted_5),
                  _hoisted_6
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_DropdownContent, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersByIndication.get(indication.id), (user, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "user-item"
                        }, [
                          _createVNode(_component_PersonPhoto, {
                            image: user.image,
                            name: user.name
                          }, null, 8, ["image", "name"]),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(user.name), 1),
                          _createVNode(_component_ProgressBar, {
                            "filled-percentage": user.percentageUser,
                            width: "30%",
                            class: "progress-bar"
                          }, null, 8, ["filled-percentage"])
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["id", "onClick"])
        ]))
      }), 128))
    ])
  ]))
}